export default "__VITE_ASSET__D9W$_787__"